<template>
  <div class="row">
    <div :class="markers.length > 0 ? 'col-md-8 d-none d-md-block' : 'col-md-12'">
      <div class="card">
        <div class="card-header pb-0">
          <div class="d-flex align-items-center">
            <h4 class="mb-0">Alertas / Siniestros</h4>
          </div>
        </div>
        <div class="row container-fluid">
          <div class="card-body px-0 pt-0 pb-2 ">
            <div class="table-responsive p-0 col-md-12">
              <table class="table align-items-center mb-0" id="my-table-alert">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Usuario
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center ">
                      Descripción SOS
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center ">
                      Fecha
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Inicio
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Fin
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Comentario
                    </th>
                    <th data-order="asc"
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Estado
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody v-if="alerts.length !== 0">
                  <tr v-for="alert in alerts" :key="alert.id">
                    <td>
                      <div class="d-flex flex-column">
                        <h5 class="mb-0 text-sm ">
                          {{ `${alert.user.name}` }}
                        </h5>
                        <h5 class="mb-0 text-sm text-wrap">
                          {{ `${alert.user.last_name}` }}
                        </h5>
                      </div>
                      <h7 class="text-xs text-secondary mb-0">{{ alert.user.phone }}</h7>
                    </td>
                    <!-- <td style="max-width: 250px;">
                      <div class="d-flex flex-column overflow-auto" style=" max-height: 100px;">
                        <span class="text-secondary text-xs font-weight-bold text-wrap">{{ alert.description ?
                          alert.description :
                          '-' }}</span>
                      </div>
                    </td> -->
                    <td>
                      <button class="btn btn-link text-dark  px-3 mb-0" @click="showDescription(alert.description)">
                        <i class="fas fa-sticky-note text-dark me-2" aria-hidden="true"></i>
                        S.O.S
                      </button>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <p class="text-xs font-weight-bold mb-0 pe-3">{{ dateSort(alert.date) }}</p>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <p class="text-xs font-weight-bold mb-0">{{ timeSort(alert.date) }}</p>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <p class="text-xs font-weight-bold mb-0 ">{{ alert.date_end ? timeSort(alert.date_end) : '-' }}
                        </p>
                      </div>
                    </td>
                    <!-- <td style="max-width: 250px;">
                      <div class="d-flex flex-column overflow-auto" style=" max-height: 100px;">
                        <span class="text-secondary text-xs font-weight-bold text-wrap">{{ alert.comment ?
                          alert.comment :
                          '-' }}</span>
                      </div>
                    </td> -->
                    <td>
                      <button class="btn btn-link text-dark  px-3 mb-0" @click="showComentario(alert.comment)">
                        <i class="fas fa-comment text-dark me-2" aria-hidden="true"></i>
                        Comentario
                      </button>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="dropdown">
                          <button :data-order="alert.status.toString()" class="btn btn-link mb-0" type="button"
                            @click="openDrop(alert.id)">
                            <span class="badge badge-pill badge-danger estatus" v-if="alert.status == 1">Nuevo<i
                                class="fa fa-chevron-down" v-if="!alert.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-warning estatus" v-if="alert.status == 2">En camino<i
                                class="fa fa-chevron-down" v-if="!alert.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-success estatus"
                              v-if="alert.status == 3 || alert.status == 4 || alert.status == 5 || alert.status == 6">Encuesta<i
                                class="fa fa-chevron-down" v-if="!alert.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-success estatus" v-if="alert.status == 7">Resuelto<i
                                class="fa fa-chevron-down" v-if="!alert.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-secondary estatus" v-if="alert.status == 8">Cancelado<i
                                class="fa fa-chevron-down" v-if="!alert.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-secondary estatus" v-if="alert.status == 9">Abortado<i
                                class="fa fa-chevron-down" v-if="!alert.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                          </button>
                          <Transition name="slide-fade">
                            <div class="" v-if="alert.openMenu">
                              <!-- <a class="cursor-pointer dropdown-item" @click="changeStatus(alert.id, 1)">Nuevo</a> -->
                              <a v-if="alert.status == 1" class="cursor-pointer dropdown-item"
                                @click="changeStatus(alert.id, 2)">En camino</a>
                              <!-- <a class="cursor-pointer dropdown-item" @click="changeStatus(alert.id, 3)">Resuelto</a> -->
                              <!-- <a class="cursor-pointer dropdown-item" @click="changeStatus(alert.id, 4)">Cancelado</a> -->
                              <a v-if="alert.status == 1 || alert.status == 3 || alert.status == 4 || alert.status == 5 || alert.status == 6"
                                class="cursor-pointer dropdown-item" @click="changeStatus(alert.id, 9)">Abortado</a>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center me-3">
                        <button class="btn btn-link text-dark  px-3 mb-0" @click="openLocation(alert.id)">
                          <i class="fas fa-map-marker-alt text-dark me-2" aria-hidden="true"></i>
                          Ver ubicación
                        </button>
                        <button class="btn btn-link text-dark  px-3 mb-0" @click="openNota(alert.id, alert.note)">
                          <i class="fas fa-paperclip text-dark me-2" aria-hidden="true"></i>
                          Notas
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition name="slide-fade">
      <div class="col-md-4 col-sm-12" v-if="markers.length > 0">
        <div class="card">
          <div class="card-body">
            <GMapMap :center="center" :zoom="12" style="width: 100%; height: 40vh">
              <GMapMarker :key="index" v-for="(m, index) in markers" :position="m.position" @click="center = m.position"
                :clickable="true" />
            </GMapMap>
            <div class="d-flex justify-content-around">
              <div class="d-flex justify-content-center">
                <button class="btn btn-link text-dark m-0" @click="markers = []"><i class="fa fa-times"></i> Cerrar
                  mapa</button>
              </div>
              <div class="d-flex justify-content-center">
                <button class="btn btn-link text-dark m-0" @click.prevent="abrirEnlace(markers[0].position)">
                  Abrir con Google
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>


  </div>
</template>


<script>
import $ from 'jquery'
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.css';
import { CABLE_URL } from '../../api/apiMeta'

export default {
  name: "alerts-table",
  props: {
    alerts: {
      type: Array,
      request: true,
    },
  },
  data() {
    return {
      myAlerts: this.alerts,
      selectedMarker: null,
      markers: [],
      center: { lat: 22.119417, lng: -101.029418 }, //coordendas iniciales del mapa
    }
  },
  mounted() {
    $('#my-table-alert').DataTable({
      order: [[6, 'asc']],
      pageLength: 50,
      lengthChange: false,
      columnDefs: [{
        targets: 6,
        orderData: 6,
        type: 'string'
      },
      { targets: [4, 5, 7], orderable: false }
      ],
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json'
      }
    });
  },
  created() {
    this.socket = new WebSocket(CABLE_URL)
    // When the socket is opened, we can send data to the server 
    this.socket.onopen = (event) => {
      console.log('Connected to server ', event);
      const msg = {
        command: 'subscribe',
        identifier: JSON.stringify({
          id: 1,
          channel: 'AlertsChannel'
        })
      }
      this.socket.send(JSON.stringify(msg))
    }

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data)

      if (data.type === 'ping')
        return

      if (data.message) {
        console.log(data.message)
        this.showAlert()
      }

    }

    this.socket.onclose = (event) => {
      console.log('Disconnected from server', event);
    }

    this.socket.onerror = (error) => {
      console.log('WebSocket error observed: ', error);
    }
  },
  unmounted() {
    this.socket.close()
  },
  methods: {
    openDrop(id) {
      let a = this.alerts.find(obj => obj.id == id);
      let band = a.openMenu;
      this.alerts.map(obj => {
        obj.openMenu = false;
      })
      a.openMenu = !band;
    },
    openLocation(id) {
      this.center = {};
      this.markers = [];
      let alert = this.alerts.find(obj => obj.id == id);
      if (alert) {
        this.markers.push({ position: { lat: parseFloat(alert.lat), lng: parseFloat(alert.lng) } });
        this.center = { lat: parseFloat(alert.lat), lng: parseFloat(alert.lng) };
      }
    },
    async changeStatus(id, status) {

      //let t = this;

      // COMENTAR CUANDO SE TENGA LA RUTA
      // let a = await t.alerts.find(obj => obj.id == id);
      // a.status = status;
      // a.openMenu = false;


      // DESCOMENTAR CUANDO SE TENGA LA RUTA
      this.plain
        .put(`/alerts/${id}`, { alert: { status } })
        .then(() => {
          //  let a = t.alerts.find(obj=>obj.id == id);
          //  a.status = status;
          //  a.openMenu = false;
          //console.log(response.data)
        })
        .catch((error) => {
          console.log("Error al actualizar el estatus del siniestro", error);
        });
    },
    dateSort(date) {
      const fechaJavascript = new Date(date);
      const day = fechaJavascript.getDate();
      const month = (fechaJavascript.getMonth() + 1).toString().length === 1 ? `0${fechaJavascript.getMonth() + 1}` : fechaJavascript.getMonth() + 1;
      const year = fechaJavascript.getFullYear();
      return `${day}-${month}-${year}`
    },
    timeSort(date) {
      const fechaJavascript = new Date(date);
      return `${fechaJavascript.getHours()}:${fechaJavascript.getMinutes()}`;
    },
    showAlert() {
      this.$parent.refreshAlerts()
      this.$swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'Alerta',
        showConfirmButton: false,
        timer: 5000
      })
      $('#my-table-alert').DataTable().destroy();
      $('#my-table-alert').DataTable({
        order: [[6, 'asc']],
        pageLength: 50,
        lengthChange: false,
        columnDefs: [{
          targets: 6,
          orderData: 6,
          type: 'string'
        },
        { targets: [4, 5, 7], orderable: false }
        ],
        language: {
          url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json'
        }
      });
    },
    showDescription(alertDescription) {
      this.$swal.fire({
        title: 'S.O.S',
        text: alertDescription.length > 0 ? `${alertDescription}` : 'Aún sin decripción...',
        confirmButtonText: 'Cerrar',
        showCloseButton: true
      })
    },
    showComentario(alertComment) {
      this.$swal.fire({
        title: 'Comentario',
        text: alertComment.length > 0 ? alertComment : 'Sin comentario...',
        confirmButtonText: 'Cerrar',
        showCloseButton: true
      })
    },
    async openNota(id, note) {
      let t = this;

      const { value: text } = await this.$swal.fire({
        input: 'textarea',
        inputLabel: 'NOTAS',
        inputValue: note ? note : '',
        inputPlaceholder: 'Esribe tus notas aqui...',
        inputAttributes: {
          'aria-label': 'Type your message here'
        },
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      })

      if (text) {
        console.log(text)
        this.plain
          .patch(`/alerts/${id}/update_out_channel`, { alert: { note: text } })
          .then(() => {
            let a = t.alerts.find(obj => obj.id == id);
            a.note = text;
            //console.log(response.data)
          })
          .catch((error) => {
            console.log("Error al actualizar la nota del siniestro", error);
          });
      }
    },
    abrirEnlace(marker) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${marker.lat},${marker.lng}`, "_blank");
    }
  },
};
</script>


